<template>
  <nav
    class="menu-classic menu-fixed menu-transparent light align-right"
    data-menu-anima="fade-in"
  >
    <div class="container">
      <div class="menu-brand">
        <a href="#">
          <img
            class="logo-default scroll-hide" :src="require('Assets/images/logo.png')" alt="logo"
          />
          <img class="logo-retina scroll-hide" :src="require('Assets/images/logo.png')" alt="logo"/>
          <img
            class="logo-default scroll-show" :src="require('Assets/images/logo.png')" alt="logo"
          />
          <img class="logo-retina scroll-show" :src="require('Assets/images/logo.png')" alt="logo"/>
        </a>
      </div>
      <i class="menu-btn" v-on:click="onMenuBtn" ></i>
      <div class="menu-cnt" >
        <ul id="main-menu">
          <li class="">
            <router-link to="/">Home</router-link>
          </li>
          <li class="">
            <router-link to="/sobre">Sobre</router-link>
          </li>
          <li class="dropdown">
            <a href="#">Produtos</a>
            <ul>
              <li class="dropdown-submenu">
                <a>Módulos</a>
                <ul>
                  <li>
                    <router-link to="/produtos/amerisolar">Amerisolar</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/dahsolar">Dah Solar</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/seraphim">Seraphim</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Inversores</a>
                <ul>
                  <li>
                    <router-link to="/produtos/chint">Chint</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/growatt">Growatt</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/saj">SAJ</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/canadian">Canadian</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Estruturas</a>
                <ul>
                  <li>
                    <router-link to="/produtos/romagnole">Romagnole</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/alumax">Alumax</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>String Box</a>
                <ul>
                  <li>
                    <router-link to="/produtos/clamper">Clamper</router-link>
                  </li>
                </ul>
              </li>

              <li class="dropdown-submenu">
                <a>Transformadores</a>
                <ul>
                  <li>
                    <router-link to="/produtos/wise">Wise</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Conectores MC4</a>
                <ul>
                  <li>
                    <router-link to="/produtos/staubli">Staubli</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Cabos</a>
                <ul>
                  <li>
                    <router-link to="/produtos/sil">Sil</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="">
            <router-link to="/contato">Contato</router-link>
          </li>
          <li>
            <a href="https://api.whatsapp.com/send?phone=554430520044&text=Ol%C3%A1!%20">
              <i class="fa fa-whatsapp"></i>&nbsp;&nbsp;WhatsApp
            </a>
          </li>
          <li class="">
            <a href="https://piedskysolar.skygroupbr.com">Cadastro</a>
          </li>

          <li>
            <a href="https://piedskysolar.skygroupbr.com"><i class="fas fa-user"></i>&nbsp;&nbsp;Login</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'HeaderHome',
  //   methods: {
  //     onMenuBtn: function(event) {
  //         console.log("onMenuBtn");
  //     }
  //   },
  methods: {
    onMenuBtn(event) {
        console.log("onMenuBtn");

        const nav = $("body nav");
        const active = $(nav).hasClass('active');
        const menu_cnt = $(nav).find('.menu-cnt');
        let h;
        if (active) {
            h = 0;
        } 
        else {
            $(menu_cnt).css({ opacity: '0', height: 'auto' });
            h = $(menu_cnt).outerHeight();
            $(menu_cnt).css({ opacity: '', height: '' });
        }

        if (!active) $(nav).addClass('active');
            $(menu_cnt).animate({
                height: h,
            }, 300, () => {
                setTimeout(() => {
                if (active) {
                    $(nav).removeClass('active');
                    $(menu_cnt).css('height', '0');
                } else {
                    $(menu_cnt).css('height', 'auto');
                }
                }, 300);
            });
        },
    },
};
</script>

<style>
  nav {
    margin-top: 0 !important;
  }
  body #app > nav .menu-brand, .menu-big-box .menu-right {
    height: 65px !important;
  }
</style>
